import React from 'react';

const Loading: React.FC = () => (
  <div className="loader-container">
    <div className="loader">Loading...</div>
  </div>
);

export default Loading;
